import {LOAD_INBOUNDDATA_ERROR, LOAD_INBOUNDDATA_LOADING, LOAD_INBOUNDDATA_SUCCESS} from "./actions";

const initialState = {
    data: [],
    loading: false,
    error: ''
};

export default function reduxSagaReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_INBOUNDDATA_LOADING: {
            return {
                ...state,
                loading: true,
                error:''
            };
        }
        case LOAD_INBOUNDDATA_SUCCESS: {
            return {
                ...state,
                data: action.data,
                loading: false
            }
        }
        case LOAD_INBOUNDDATA_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.error
            };
        }
        default: {
            return state;
        }
    }
}